// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import subscribeHubspotForm from "@steiner/App/SharedStyles/Subscribe/subscribeHubspotForm";
import { subscribeStyles } from "@steiner/Overrides/Widgets/Basic/Subscribe";
import { layoutContainer, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

subscribeStyles.mainGridContainer = {
    gap: 8,
    css: css`
        &&& {
            max-width: 328px;
        }
        ${xScreen("lte", "xs")} {
            &&& {
                max-width: 100%;
            }
        }
    `,
};

subscribeStyles.titleGridItem = {
    width: 12,
};

subscribeStyles.titleLabel = {
    variant: "h6",
    css: css`
        margin-bottom: 0;
    `,
};

subscribeStyles.descriptionGridItem = {
    width: 12,
};

subscribeStyles.descriptionText = {
    css: css`
        margin-bottom: 0;
    `,
};

subscribeStyles.emailGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        gap: 12px;
    `,
};

subscribeStyles.emailTextField = {};

subscribeStyles.emailButton = {};

subscribeStyles.disclaimerGridItem = {
    width: 12,
};

subscribeStyles.disclaimerText = {
    css: css`
        font-size: 12px;
    `,
};

subscribeStyles.externalProviderGridItem = {
    width: 12,
    css: css`
        width: 100%;
        ${subscribeHubspotForm}
    `,
};
